import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axiosClient from "../../axios-client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import RegisterWithOTP from "../layout/RegisterModal";
import LoginModal from "../layout/LoginModal";

const PricingPlan = () => {
  const navigate = useNavigate();
  const [plans, setPlans] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const [modalVisible, setModalVisible] = useState(false); // For modal visibility
  const [successModel, setSuccessModel] = useState(false);
  const [modalMessage, setModalMessage] = useState(""); // Message to display in the modal
  const [loading, setLoading] = useState(false);
  const [registerModal, setRegisterModal] = useState(false);
  const [loginModal, setLoginModal] = useState(false);
  const [planDetails, setPlanDetails] = useState(null);
  useEffect(() => {
    const fetchPlans = async () => {
      try {
        setLoading(true);
        const response = await axiosClient.get("/plans/getall");
        if (response.data.success) {
          const sortedPlans = response.data.plans.sort(
            (a, b) => a.price - b.price
          );

          setPlans(sortedPlans);
        }
      } catch (error) {
        console.error("Error fetching plans:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPlans();
  }, []);
  const toggleAnswer = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const filterFeatures = (features) => {
    return Object.entries(features)
      .filter(([key, value]) => value !== false && value !== 0) // Filter out false and 0
      .reduce((obj, [key, value]) => {
        obj[key] = value;
        return obj;
      }, {});
  };
  const handleChoosePlan = async (planId, billingCycle) => {
    if (!planId) {
      navigate("/contact-us");
      return;
    }
    const userId = localStorage.getItem("userID"); // Assuming user ID is stored in localStorage
    const plan = {
      planId: planId,
      billingCycle: billingCycle,
    };
    setPlanDetails(plan);
    if (!userId) {
      setModalMessage(
        "Please login or Register to opt for the subscriptions.!"
      ); // Show message if user is not logged in
      setModalVisible(true);
      return;
    }

    try {
      setLoading(true);

      const response = await axiosClient.post("/subscriptions/purchase-plan", {
        userId,
        planId,
      });

      // if (response.data.message ==="Subscription created successfully" && response.status===200) {
      if (response.status === 200) {
        setModalMessage("Plan selected successfully!");
        // Success message
        if (response.data.approvalUrl) {
          window.location.href = response.data.approvalUrl; // Redirect to PayPal
        }
      } else {
        console.log(response.data);
        setModalMessage(response.data?.message || "Failed to select the plan."); // Failure message
      }
    } catch (error) {
      console.error("Error selecting plan:", error);

      // Check the status code and set the modal message accordingly
      if (error.response) {
        // If error.response exists, it means the server returned an error response
        const errorMessage =
          error.response.data?.error ||
          error.response.data?.message ||
          "An error occurred. Please try again.";
        setModalMessage(errorMessage);
      } else {
        setModalMessage("An unknown error occurred. Please try again.");
      }
    } finally {
      setLoading(false);
    }

    setModalVisible(true); // Show the modal regardless of success or failure
  };

  // const handleChoosePlan = async (planId, billingCycle) => {
  //   const userId = localStorage.getItem("userID"); // Assuming user ID is stored in localStorage
  //   if (!userId) {
  //     setModalMessage("User not logged in!"); // Show message if user is not logged in
  //     setModalVisible(true);
  //     return;
  //   }

  //   try {
  //     const requestData = planId
  //       ? { userId, planId } // Regular plan request
  //       : { userId }; // Custom plan request
  //     setLoading(true);

  //     const response = await axiosClient.post("/subscriptions/request-plan", requestData);
  //     // const response = await axiosClient.post("/subscriptions/purchase-plan", {
  //     //   userId,
  //     //   planId,
  //     // });
  //     console.log(userId);

  //     // if (response.data.message ==="Subscription created successfully" && response.status===200) {
  //     if (response.status === 200) {
  //       setModalMessage(response.data.message);
  //       setModalMessage("Plan selected successfully!");
  //       // Success message
  //       if (response.data.approvalUrl) {
  //         window.location.href = response.data.approvalUrl; // Redirect to PayPal
  //       }
  //     } else {
  //       setModalMessage("Failed to select the plan.");
  //       console.log(response.data);
  //       setModalMessage("Failed to select the plan."); // Failure message
  //     }
  //   } catch (error) {
  //     console.error("Error selecting plan:", error);

  //     // Check the status code and set the modal message accordingly
  //     if (error.response) {// If error.response exists, it means the server returned an error response
  //       const status = error.response.status;
  //       const errorMessage =
  //         error.response.data.message || "An error occurred. Please try again.";

  //       setModalMessage(`Error ${status}: ${errorMessage}`);
  //       if (status === 400) {
  //         setModalMessage(` ${errorMessage}`);
  //       } else if (status === 404) {
  //         setModalMessage(` ${errorMessage}`);
  //       } else {
  //         setModalMessage(`Error ${status}: ${errorMessage}`);
  //       }
  //     } else {
  //       setModalMessage("An unknown error occurred. Please try again.");
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  //   setModalVisible(true); // Show the modal regardless of success or failure
  // };

  const closeModal = () => {
    setModalVisible(false);
    setSuccessModel(false);
    setRegisterModal(false);
    setLoginModal(false);
    setPlanDetails(null);
    setModalMessage("");
  };
  const onRegisterSuccess = () => {
    closeModal();
    setModalMessage(
      "Thank you for registering! A payment link will be sent to your email shortly. Your account will be activated upon payment confirmation."
    );
    setSuccessModel(true);
    // setLoginModal(true);
  };
  const onLoginSuccess = () => {
    closeModal();
    setModalMessage("Login successful!");
    setLoginModal(false);
    window.location.reload();
  };

  const handleLogin = () => {
    setRegisterModal(false);
    setLoginModal(true);
  };
  const handleRegister = () => {
    setLoginModal(false);
    setRegisterModal(true);
  };

  return (
    <div className="bg-blue-50 py-8 sm:py-12 md:py-16 min-h-screen flex flex-col justify-between">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-4 sm:mb-6 font-urban">
          Pricing Plan
        </h2>
        <p className="text-center md:text-lg mb-8 sm:mb-12 font-urban text-sm sm:text-base font-semibold">
          Flexible Plans for Every Market Research Need
        </p>
        {loading ? (
          <div className="flex justify-center items-center">
            <img src="/images/paymentloading.gif" alt="Loading..." />
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 font-dmSans">
            {plans?.map((plan, index) => {
              const { _id, name, price, billingCycle, features } = plan; // Assuming _id is the plan's unique ID
              const activeFeatures = filterFeatures(features);
              return (
                <div
                  key={index}
                  className="bg-white rounded-lg shadow-lg p-4 sm:p-6 md:p-8 transition-all lg:h-fit duration-500 ease-in-out hover:scale-105 box-pricing hover:text-white"
                >
                  <h3 className="text-lg sm:text-xl font-semibold mb-2 sm:mb-3">
                    {name}
                  </h3>
                  <p className="text-2xl sm:text-3xl font-bold mb-2 sm:mb-3">
                    USD $ {price}(Monthly)
                  </p>
                  <p className="text-sm mb-2">(Billed {billingCycle})</p>
                  {/* <ul className="mb-2 sm:mb-4 space-y-1">
                    {Object.keys(activeFeatures)
                      .filter((featureKey) =>
                        [
                          "globalMarketStatistics",
                          "RegionAndCountriesMarketStatistics",
                          "memberReportPrice",
                          "graphDownloadLimit",
                          "graphDownloadFormats",
                          "newsletters",
                          "industryAnalysisReports",
                          "customizationHours",
                          "consultationHours",
                          "companyProfilesAccess",
                          "dataCitationLicense",
                          "customerService",
                        ].includes(featureKey)
                      )
                      .map((featureKey, i) => {
                        const featureValue = activeFeatures[featureKey];
                        if (featureValue === null || featureValue === undefined)
                          return null;

                        // Convert true/false to Yes/No
                        const displayValue =
                          typeof featureValue === "boolean"
                            ? featureValue
                              ? "Yes"
                              : "No"
                            : Array.isArray(featureValue)
                            ? featureValue.join(", ")
                            : featureValue;

                        return (
                          <li
                            key={i}
                            className="flex items-start text-gray-500 font-medium text-xs sm:text-sm pb-1"
                          >
                            <span className="text-red-500 mr-2 flex-shrink-0">
                              <img
                                src="images/tick.png"
                                alt="tick"
                                className="w-4 h-4 sm:w-5 sm:h-5"
                              />
                            </span>
                            <span className="flex-1">
                              {featureKey === "graphDownloadFormats" ? (
                                <>Graph Download Formats: {displayValue}</>
                              ) : (
                                <>
                                  {featureKey
                                    .replace(/([A-Z])/g, " $1")
                                    .replace(/^./, (str) => str.toUpperCase())}
                                  : {displayValue}
                                </>
                              )}
                            </span>
                          </li>
                        );
                      })}
                  </ul> */}
                  <ul className="mb-2 sm:mb-4 space-y-1">
                    {Object.keys(activeFeatures)
                      .filter((featureKey) =>
                        [
                          "globalMarketStatistics",
                          "RegionAndCountriesMarketStatistics",
                          "memberReportPrice",
                          "graphDownloadLimit",
                          "graphDownloadFormats",
                          "newsletters",
                          "industryAnalysisReports",
                          "customizationHours",
                          "consultationHours",
                          "companyProfilesAccess",
                          "dataCitationLicense",
                          "customerService",
                        ].includes(featureKey)
                      )
                      .map((featureKey, i) => {
                        const featureValue = activeFeatures[featureKey];
                        if (featureValue === null || featureValue === undefined)
                          return null;

                        // Convert true/false to Yes/No
                        const displayValue =
                          typeof featureValue === "boolean"
                            ? featureValue
                              ? "Yes"
                              : "No"
                            : Array.isArray(featureValue)
                            ? featureValue.join(", ")
                            : featureValue;

                        return (
                          <li
                            key={i}
                            className="flex items-start text-gray-500 font-medium text-xs sm:text-sm pb-1"
                          >
                            <span className="text-red-500 mr-2 flex-shrink-0">
                              <img
                                src="images/tick.png"
                                alt="tick"
                                className="w-4 h-4 sm:w-5 sm:h-5"
                              />
                            </span>
                            <span className="flex-1">
                              {featureKey === "graphDownloadFormats" ? (
                                <>
                                  Graph Download Formats:{" "}
                                  <strong>{displayValue}</strong>
                                </>
                              ) : (
                                <>
                                  {featureKey
                                    .replace(/([A-Z])/g, " $1")
                                    .replace(/^./, (str) => str.toUpperCase())}
                                  :{" "}
                                  <strong
                                    style={{
                                      fontWeight: "bold",
                                      color: "black",
                                    }}
                                  >
                                    {displayValue}
                                  </strong>
                                </>
                              )}
                            </span>
                          </li>
                        );
                      })}
                  </ul>

                  <button
                    disabled={price === 0}
                    onClick={() => handleChoosePlan(_id, billingCycle)}
                    className="w-full py-2 my-2 sm:my-4   bg-black text-white rounded-lg hover:bg-white hover:text-black transition-colors duration-300 ease-in-out text-sm sm:text-base"
                  >
                    {price === 0 ? "Choose" : "Choose"}
                  </button>
                </div>
              );
            })}
          </div>
        )}
        <br />
        <div className="relative  justify-center">
          <p className="text-lg sm:text-xl font-semibold mb-2 sm:mb-3 text-center">
            Price packages not fitting your market research needs? Let us know,
            and we'll custom-build one for you.
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <button
              onClick={() => navigate("/contact-us")}
              className=" py-1 my-2 sm:my-3 bg-black text-black border border-black rounded-lg bg-white hover:bg-black hover:text-white transition-colors duration-300 ease-in-out text-sm sm:text-base cursor-pointer"
              style={{ width: "150px", fontWeight: "500" }}
            >
              Custom Pricing{" "}
              <FontAwesomeIcon
                icon={faArrowRight}
                style={{ marginLeft: "6px" }}
              />
            </button>
          </div>
        </div>
      </div>
      <RegisterWithOTP
        isOpen={registerModal}
        closeModal={closeModal}
        planDetails={planDetails}
        onRegisterSuccess={onRegisterSuccess}
        payload={handleLogin}
      />
      <LoginModal
        isOpen={loginModal}
        payload={handleRegister}
        closeModal={closeModal}
        onLoginSuccess={onLoginSuccess}
      />
      {/* Modal */}
      {modalVisible && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-sm w-full text-center shadow-2xl">
            <div className="flex justify-end">
              <div
                onClick={closeModal}
                className="text-gray-500 hover:text-black rounded-lg cursor-pointer"
              >
                <img
                  src="images/close1.png"
                  alt="close"
                  className="w-3 h-3 sm:w-5 sm:h-5"
                />
              </div>
            </div>
            <p className="text-lg font-semibold mt-2">{modalMessage}</p>
            {!localStorage.getItem("userID") ? (
              <div className="flex justify-center space-x-4 mt-4">
                <button
                  onClick={() => {
                    setModalVisible(false);
                    setRegisterModal(true);
                  }}
                  className="py-2 px-5 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors"
                >
                  Register
                </button>
                <button
                  onClick={() => {
                    setModalVisible(false);
                    setLoginModal(true);
                  }}
                  className="py-2 px-5 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors"
                >
                  Login
                </button>
              </div>
            ) : (
              <div className="flex justify-center mt-5">
                <button
                  onClick={closeModal}
                  className="py-2 px-6 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors"
                >
                  OK
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      {successModel && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white rounded-lg p-6 max-w-sm w-full text-center ">
            <div className="flex justify-end">
              <div
                onClick={closeModal}
                className=" text-white rounded-lg cursor-pointer"
              >
                <img
                  src="images/close1.png"
                  alt="tick"
                  className="w-3 h-3 sm:w-5 sm:h-5"
                />
              </div>
            </div>
            {/* <p className="text-lg font-semibold">{modalMessage}</p> */}
            <div className="flex justify-center space-x-4">{modalMessage}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PricingPlan;
